import React from 'react';

const AllOrders = () => {
  return <div>all orderd by people</div>;
};

export default AllOrders;
